import React, { useEffect, useState } from 'react';
import '../../style/Profilo/Profilo.scss'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import EditInfo from '../../components/Gas/Profilo/EditInfo';
import IconAndName from '../../components/Gas/Profilo/IconAndName'
import ListaPods from '../../components/Gas/Profilo/ListaPods'
import MoreInfo from '../../components/Gas/Profilo/MoreInfo'
import PayMethod from '../../components/Gas/Profilo/PayMethod'
import DetailPod from '../../components/Gas/Profilo/DetailPod';


function ProfiloGas() {
    const navigate = useNavigate()
    const [editInfo, setEditInfo] = useState(false)
    const [handleDetailPod, setHandleDetailPod] = useState(false)
    const [statePod, setStatePod] = useState()
    
    useEffect(() => {
        document.body.style.touchAction = null;
        document.body.style.overflow = null;
    },[])

    return (
      <>
        <header className='profiloHeader'>
            {editInfo ? (
                <>
                    <ArrowBackIcon onClick={() => setEditInfo(false)}/>
                    <p>Profilo</p>
                </>
            ) : handleDetailPod ? (
                <>
                    <ArrowBackIcon onClick={() => setHandleDetailPod(false)}/>
                    <p>Profilo</p>
                </>
            ) : (
                <>
                    <ArrowBackIcon onClick={() => navigate(-1)}/>
                    <p>Profilo</p>
                </>
            )}
        </header>
        {
            editInfo ? (
                <div className="editInfo">
                    <EditInfo setEditInfo={setEditInfo}  />
                </div>
            ) : handleDetailPod ?(
                <div className="detailPod">
                    <DetailPod state={statePod}  />
                </div>
            ) : (
                <div className="profilo">
                    <IconAndName />
                    <MoreInfo setEditInfo={setEditInfo} />
                    <div className="forniture">
                        <p className="label">Le tue forniture</p>
                        <ListaPods setHandleDetailPod={setHandleDetailPod} setStatePod={setStatePod} />
                    </div>
                    <PayMethod />
                </div>
            )
        }
      </>
  );
}

export default ProfiloGas;
